import { ChevronRightIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import type { FunctionComponent } from "react";
import { NavLink } from "react-router-dom";

type BreadcrumbElementProps = {
	text: string;
	url?: string;
};

const BreadcrumbElement: FunctionComponent<BreadcrumbElementProps> = ({ text, url }) => {
	return (
		<li className={clsx("group flex items-center justify-center gap-x-2")}>
			<ChevronRightIcon className="size-5 font-normal text-gray-500" />
			{url ? (
				<NavLink
					className="font-medium tracking-wide text-gray-500 hover:text-gray-700"
					to={url}
				>
					{text}
				</NavLink>
			) : (
				<span className="text-gray-500">{text}</span>
			)}
		</li>
	);
};

export default BreadcrumbElement;
